import { css } from '@emotion/core'
import { mediumUp, largeUp } from 'Utils'
import theme from 'Theme'

export default () => {
  const { colors, typography, spacing, mixins } = theme

  return css`
    font-size: ${typography.baseFontSize};
    display: flex;
    background-color: ${colors.bodyBackground};
    border: 1px solid ${colors.borderGrey};
    flex-direction: column;

    &:hover {
      ${mixins.cardBoxShadow(theme)}
    }

    @media ${largeUp} {
      flex-direction: row;
    }

    .al__row1,
    .al__row2 {
      @media ${largeUp} {
        width: 60%;
      }
    }

    .al__row1 {
      padding: ${spacing.vertical.medium};
      @media ${mediumUp} {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      h2 {
        ${mixins.sectionHeading(theme)}

        @media ${largeUp} {
          min-height: 50px;
        }

        @media ${largeUp} {
          width: 90%;
        }
        margin: 0 auto;
      }
    }

    .al__category-name {
      font-size: ${theme.typography.sizes.small};
      ${mixins.subText(theme)}
    }
  `
}
